import { render, staticRenderFns } from "./MaterialSummary.vue?vue&type=template&id=68ecbd8a&scoped=true&"
import script from "./MaterialSummary.vue?vue&type=script&lang=js&"
export * from "./MaterialSummary.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSummary.vue?vue&type=style&index=0&id=68ecbd8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ecbd8a",
  null
  
)

export default component.exports